var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "ValidationObserver",
        { ref: "observer" },
        [
          _c(
            "div",
            { staticClass: "input-header" },
            [
              _c("BaseInput", {
                attrs: {
                  id: `policy-name-${_vm.index}`,
                  field: {
                    type: "input",
                    isHorizontal: true,
                    label: "Nombre",
                    placeholder: "Nombre del risk policy",
                  },
                  rules: "required",
                  size: "is-small",
                },
                model: {
                  value: _vm.localPolicy.policyName,
                  callback: function ($$v) {
                    _vm.$set(_vm.localPolicy, "policyName", $$v)
                  },
                  expression: "localPolicy.policyName",
                },
              }),
              _c("BaseInput", {
                attrs: {
                  id: `policy-description-${_vm.index}`,
                  field: {
                    type: "input",
                    isHorizontal: true,
                    label: "Descripción",
                    placeholder: "Descripción de la póliza",
                  },
                  rules: "required",
                  size: "is-small",
                },
                model: {
                  value: _vm.localPolicy.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.localPolicy, "description", $$v)
                  },
                  expression: "localPolicy.description",
                },
              }),
            ],
            1
          ),
          _c("ValidationProvider", {
            attrs: { rules: "required" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ errors }) {
                  return [
                    _c("b-taginput", {
                      attrs: {
                        id: "`policy-tags-${index}`",
                        data: _vm.tags,
                        "allow-new": "",
                        field: "tags",
                        icon: "label",
                        size: "is-small",
                        placeholder: "Agregar un tag",
                        "data-cy": `policy-tags-${_vm.index}`,
                      },
                      model: {
                        value: _vm.localPolicy.tags,
                        callback: function ($$v) {
                          _vm.$set(_vm.localPolicy, "tags", $$v)
                        },
                        expression: "localPolicy.tags",
                      },
                    }),
                    _c("p", { staticClass: "help is-danger" }, [
                      _vm._v(_vm._s(errors[0])),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("div", { staticClass: "columns fields-policies" }, [
            _c(
              "div",
              { staticClass: "column is-6-desktop-only" },
              [
                _c("BaseInput", {
                  attrs: {
                    id: "policy-active-" + _vm.index,
                    field: {
                      type: "switch",
                      isHorizontal: true,
                      label: "Activo",
                      placeholder: "Activo",
                      size: "is-small",
                    },
                    rules: "",
                  },
                  model: {
                    value: _vm.localPolicy.isActive,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "isActive", $$v)
                    },
                    expression: "localPolicy.isActive",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-subsegment-" + _vm.index,
                    field: {
                      type: "select",
                      isHorizontal: true,
                      label: "Subsegmento",
                      placeholder: "Selecciona un subsegmento",
                      options: _vm.subSegment.map((value) => ({
                        value,
                        label: value,
                      })),
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.subSegment,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "subSegment", $$v)
                    },
                    expression: "localPolicy.subSegment",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-min-ltv-" + _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "LTV min",
                      placeholder: "0.8",
                    },
                    rules: "required|max_value:1|min_value:0",
                    size: "is-small",
                  },
                  model: {
                    value:
                      _vm.localPolicy.subSegmentConditions[
                        _vm.getSubsegmentIndex(
                          _vm.localPolicy.subSegmentConditions,
                          "offerResponse.loanToValueHome"
                        )
                      ].minValue,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localPolicy.subSegmentConditions[
                          _vm.getSubsegmentIndex(
                            _vm.localPolicy.subSegmentConditions,
                            "offerResponse.loanToValueHome"
                          )
                        ],
                        "minValue",
                        $$v
                      )
                    },
                    expression:
                      "localPolicy.subSegmentConditions[getSubsegmentIndex(localPolicy.subSegmentConditions, 'offerResponse.loanToValueHome')].minValue",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-min-credit-amount-" + _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "Monto crédito min",
                      placeholder: "100000",
                    },
                    rules: "required|numeric",
                    size: "is-small",
                  },
                  model: {
                    value:
                      _vm.localPolicy.subSegmentConditions[
                        _vm.getSubsegmentIndex(
                          _vm.localPolicy.subSegmentConditions,
                          "offerResponse.creditAmount"
                        )
                      ].minValue,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localPolicy.subSegmentConditions[
                          _vm.getSubsegmentIndex(
                            _vm.localPolicy.subSegmentConditions,
                            "offerResponse.creditAmount"
                          )
                        ],
                        "minValue",
                        $$v
                      )
                    },
                    expression:
                      "localPolicy.subSegmentConditions[getSubsegmentIndex(localPolicy.subSegmentConditions, 'offerResponse.creditAmount')].minValue",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-purpose-" + _vm.index,
                    field: {
                      type: "select",
                      isHorizontal: true,
                      label: "Propósito",
                      placeholder: "Compra de vivienda",
                      options: _vm.purpose.map((value) => ({
                        value,
                        label: value,
                      })),
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.purpose,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "purpose", $$v)
                    },
                    expression: "localPolicy.purpose",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-maximum-backend-ratio-" + _vm.index,
                    field: {
                      type: "number",
                      prefixPosition: "right",
                      prefix: "%",
                      isHorizontal: true,
                      label: "Back end ratio max",
                      placeholder: "0.36",
                    },
                    rules: "required|max_value:1|min_value:0",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.maximumBackendRatio,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "maximumBackendRatio", $$v)
                    },
                    expression: "localPolicy.maximumBackendRatio",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-maximum-property-ltv-" + _vm.index,
                    field: {
                      type: "number",
                      prefixPosition: "right",
                      prefix: "%",
                      isHorizontal: true,
                      label: "LTV propiedad max",
                      placeholder: "0.8",
                    },
                    rules: "required|max_value:1|min_value:0",
                  },
                  model: {
                    value: _vm.localPolicy.maximumPropertyLTV,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "maximumPropertyLTV", $$v)
                    },
                    expression: "localPolicy.maximumPropertyLTV",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-investment-weight-" + _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "Investment Weight",
                      placeholder: "0.5",
                    },
                    rules: "required|max_value:1|min_value:0",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.investmentWeight,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "investmentWeight", $$v)
                    },
                    expression: "localPolicy.investmentWeight",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-property-type-factor-" + _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "Factor tipo de propiedad",
                      placeholder: "1.2",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.propertyTypeFactor,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "propertyTypeFactor", $$v)
                    },
                    expression: "localPolicy.propertyTypeFactor",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-interest-type-" + _vm.index,
                    field: {
                      type: "select",
                      isHorizontal: true,
                      label: "Tipo de interés",
                      placeholder: "Fijo",
                      options: _vm.interestType.map((value) => ({
                        value,
                        label: value,
                      })),
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.interestType,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "interestType", $$v)
                    },
                    expression: "localPolicy.interestType",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-credit-insurance-financing-" + _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "Financiamiento seguro de crédito",
                      placeholder: "0.1",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.creditInsuranceFinancing,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "creditInsuranceFinancing", $$v)
                    },
                    expression: "localPolicy.creditInsuranceFinancing",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-credit-insurance-number-of-months-" + _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "Meses de cobro cuota seguro de crédito",
                      placeholder: "12",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.creditInsuranceNumberOfMonths,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localPolicy,
                        "creditInsuranceNumberOfMonths",
                        $$v
                      )
                    },
                    expression: "localPolicy.creditInsuranceNumberOfMonths",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-credit-insurance-rate-" + _vm.index,
                    field: {
                      type: "number",
                      prefixPosition: "right",
                      prefix: "%",
                      isHorizontal: true,
                      label: "Tasa del seguro de crédito",
                      placeholder: "0.01",
                    },
                    rules: "required|max_value:1|min_value:0",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.creditInsuranceRate,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "creditInsuranceRate", $$v)
                    },
                    expression: "localPolicy.creditInsuranceRate",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id:
                      "policy-unemployment-insurance-monthly-rate-" + _vm.index,
                    field: {
                      type: "number",
                      prefixPosition: "right",
                      prefix: "%",
                      isHorizontal: true,
                      label: "Tasa seguro desempleo",
                      placeholder: "0.002",
                    },
                    rules: "required|max_value:1|min_value:0",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.unemploymentInsuranceMonthlyRate,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localPolicy,
                        "unemploymentInsuranceMonthlyRate",
                        $$v
                      )
                    },
                    expression: "localPolicy.unemploymentInsuranceMonthlyRate",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-grace-months-interest-method-" + _vm.index,
                    field: {
                      type: "select",
                      isHorizontal: true,
                      label: "Método interés gracia",
                      placeholder: "Simple",
                      options: _vm.graceMonthsInterestMethod.map((value) => ({
                        value,
                        label: value,
                      })),
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.graceMonthsInterestMethod,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localPolicy,
                        "graceMonthsInterestMethod",
                        $$v
                      )
                    },
                    expression: "localPolicy.graceMonthsInterestMethod",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-appraisal-expenses-" + _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "Gastos Tasación",
                      placeholder: "50000",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.appraisalExpenses,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "appraisalExpenses", $$v)
                    },
                    expression: "localPolicy.appraisalExpenses",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-notary-expenses-" + _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "Gastos Notario",
                      placeholder: "20000",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.notaryExpenses,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "notaryExpenses", $$v)
                    },
                    expression: "localPolicy.notaryExpenses",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-credit-tax-rate-" + _vm.index,
                    field: {
                      type: "number",
                      prefixPosition: "right",
                      prefix: "%",
                      isHorizontal: true,
                      label: "Tasa crédito",
                      placeholder: "0.19",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.creditTaxRate,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "creditTaxRate", $$v)
                    },
                    expression: "localPolicy.creditTaxRate",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-appraisal-expenses-percentage-" + _vm.index,
                    field: {
                      type: "number",
                      prefixPosition: "right",
                      prefix: "%",
                      isHorizontal: true,
                      label: "% Gastos Tasación",
                      placeholder: "0.05",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.appraisalExpensesPercentage,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localPolicy,
                        "appraisalExpensesPercentage",
                        $$v
                      )
                    },
                    expression: "localPolicy.appraisalExpensesPercentage",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-notary-expenses-percentage-" + _vm.index,
                    field: {
                      type: "number",
                      prefixPosition: "right",
                      prefix: "%",
                      isHorizontal: true,
                      label: "% Gastos Notario",
                      placeholder: "0.02",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.notaryExpensesPercentage,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "notaryExpensesPercentage", $$v)
                    },
                    expression: "localPolicy.notaryExpensesPercentage",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-credit-tax-rate-percentage-" + _vm.index,
                    field: {
                      type: "number",
                      prefixPosition: "right",
                      prefix: "%",
                      isHorizontal: true,
                      label: "% Tasa crédito",
                      placeholder: "0.01",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.creditTaxRatePercentage,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "creditTaxRatePercentage", $$v)
                    },
                    expression: "localPolicy.creditTaxRatePercentage",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-credit-max-amount-" + _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "Monto Máx Crédito",
                      placeholder: "1000000",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.creditMaxAmount,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "creditMaxAmount", $$v)
                    },
                    expression: "localPolicy.creditMaxAmount",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-target-age-" + _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "Edad Objetivo",
                      placeholder: "30",
                      prefix: "",
                    },
                    rules: "required|numeric",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.targetAge,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "targetAge", $$v)
                    },
                    expression: "localPolicy.targetAge",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id:
                      "policy-life-insurance-monthly-rate-ranges-min-age-" +
                      _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "Edad Mínima",
                      placeholder: "18",
                    },
                    rules: "required|numeric",
                    size: "is-small",
                  },
                  model: {
                    value:
                      _vm.localPolicy.lifeInsuranceMonthlyRateRanges[0].minAge,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localPolicy.lifeInsuranceMonthlyRateRanges[0],
                        "minAge",
                        $$v
                      )
                    },
                    expression:
                      "localPolicy.lifeInsuranceMonthlyRateRanges[0].minAge",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id:
                      "policy-life-insurance-debtor-monthly-rate-ranges-" +
                      _vm.index,
                    field: {
                      type: "number",
                      prefixPosition: "right",
                      prefix: "%",
                      isHorizontal: true,
                      label: "Tasa Seguro Vida",
                      placeholder: "0.001",
                    },
                    rules: "required|max_value:1|min_value:0",
                    size: "is-small",
                  },
                  model: {
                    value:
                      _vm.localPolicy.lifeInsuranceDebtorMonthlyRateRanges[0]
                        .lifeInsuranceMonthlyRate,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localPolicy.lifeInsuranceDebtorMonthlyRateRanges[0],
                        "lifeInsuranceMonthlyRate",
                        _vm._n($$v)
                      )
                    },
                    expression:
                      "localPolicy.lifeInsuranceDebtorMonthlyRateRanges[0].lifeInsuranceMonthlyRate",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id:
                      "policy-life-insurance-debtor-monthly-rate-ranges-max-age-state-" +
                      _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "Edad Máxima",
                      prefix: "",
                      placeholder: "65",
                    },
                    rules: "required|numeric",
                    size: "is-small",
                  },
                  model: {
                    value:
                      _vm.localPolicy.lifeInsuranceDebtorMonthlyRateRanges[0]
                        .maxAge,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localPolicy.lifeInsuranceDebtorMonthlyRateRanges[0],
                        "maxAge",
                        $$v
                      )
                    },
                    expression:
                      "localPolicy.lifeInsuranceDebtorMonthlyRateRanges[0].maxAge",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id:
                      "policy-life-insurance-codebtor-monthly-rate-ranges-min-age-state-" +
                      _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "Edad Mínima",
                      prefix: "",
                      placeholder: "65",
                    },
                    rules: "required|numeric",
                    size: "is-small",
                  },
                  model: {
                    value:
                      _vm.localPolicy.lifeInsuranceCodebtorMonthlyRateRanges[0]
                        .minAge,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localPolicy
                          .lifeInsuranceCodebtorMonthlyRateRanges[0],
                        "minAge",
                        $$v
                      )
                    },
                    expression:
                      "localPolicy.lifeInsuranceCodebtorMonthlyRateRanges[0].minAge",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id:
                      "policy-credit-insurance-fee-term-definition-" +
                      _vm.index,
                    field: {
                      type: "select",
                      isHorizontal: true,
                      label: "Definición Plazo Seguro",
                      placeholder: "Anual",
                      options: _vm.creditInsuranceFeeTermDefinition.map(
                        (value) => ({ value, label: value })
                      ),
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.creditInsuranceFeeTermDefinition,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localPolicy,
                        "creditInsuranceFeeTermDefinition",
                        $$v
                      )
                    },
                    expression: "localPolicy.creditInsuranceFeeTermDefinition",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-default-number-of-grace-months-" + _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "Meses Gracia",
                      placeholder: "3",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.defaultNumberOfGraceMonths,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localPolicy,
                        "defaultNumberOfGraceMonths",
                        $$v
                      )
                    },
                    expression: "localPolicy.defaultNumberOfGraceMonths",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-version-" + _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "Versión",
                      placeholder: "1.0",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.version,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "version", $$v)
                    },
                    expression: "localPolicy.version",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "column is-6-desktop-only" },
              [
                _c("BaseInput", {
                  attrs: {
                    id: "policy-segment-" + _vm.index,
                    field: {
                      type: "select",
                      isHorizontal: true,
                      label: "Segmento",
                      placeholder: "SUBSIDY",
                      options: _vm.segment.map((value) => ({
                        value,
                        label: value,
                      })),
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.segment,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "segment", $$v)
                    },
                    expression: "localPolicy.segment",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-subsegment-description-" + _vm.index,
                    field: {
                      type: "input",
                      isHorizontal: true,
                      label: "Descripción subsegmento",
                      placeholder:
                        "Política de riesgo para créditos hipotecarios",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.subSegmentDescription,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "subSegmentDescription", $$v)
                    },
                    expression: "localPolicy.subSegmentDescription",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-max-ltv-" + _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "LTV max",
                      placeholder: "80",
                    },
                    rules: "required|max_value:1|min_value:0",
                    size: "is-small",
                  },
                  model: {
                    value:
                      _vm.localPolicy.subSegmentConditions[
                        _vm.getSubsegmentIndex(
                          _vm.localPolicy.subSegmentConditions,
                          "offerResponse.loanToValueHome"
                        )
                      ].maxValue,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localPolicy.subSegmentConditions[
                          _vm.getSubsegmentIndex(
                            _vm.localPolicy.subSegmentConditions,
                            "offerResponse.loanToValueHome"
                          )
                        ],
                        "maxValue",
                        $$v
                      )
                    },
                    expression:
                      "localPolicy.subSegmentConditions[getSubsegmentIndex(localPolicy.subSegmentConditions, 'offerResponse.loanToValueHome')].maxValue",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-max-credit-amount-" + _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "Monto crédito max",
                      placeholder: "1000000",
                    },
                    rules: "required|numeric",
                    size: "is-small",
                  },
                  model: {
                    value:
                      _vm.localPolicy.subSegmentConditions[
                        _vm.getSubsegmentIndex(
                          _vm.localPolicy.subSegmentConditions,
                          "offerResponse.creditAmount"
                        )
                      ].maxValue,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localPolicy.subSegmentConditions[
                          _vm.getSubsegmentIndex(
                            _vm.localPolicy.subSegmentConditions,
                            "offerResponse.creditAmount"
                          )
                        ],
                        "maxValue",
                        $$v
                      )
                    },
                    expression:
                      "localPolicy.subSegmentConditions[getSubsegmentIndex(localPolicy.subSegmentConditions, 'offerResponse.creditAmount')].maxValue",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-icon-" + _vm.index,
                    field: {
                      type: "input",
                      isHorizontal: true,
                      label: "Icono",
                      placeholder: "home",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.icon,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "icon", $$v)
                    },
                    expression: "localPolicy.icon",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-maximum-frontend-ratio-" + _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "Ratio max",
                      placeholder: "0.3",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.maximumFrontendRatio,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "maximumFrontendRatio", $$v)
                    },
                    expression: "localPolicy.maximumFrontendRatio",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-maximum-credit-ltv-" + _vm.index,
                    field: {
                      type: "number",
                      prefixPosition: "right",
                      prefix: "%",
                      isHorizontal: true,
                      label: "Crédito Max LTV",
                      placeholder: "0.8",
                    },
                    rules: "required|min_value:0|max_value:1",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.maximumCreditLTV,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "maximumCreditLTV", $$v)
                    },
                    expression: "localPolicy.maximumCreditLTV",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-amortization-method-" + _vm.index,
                    field: {
                      type: "select",
                      isHorizontal: true,
                      label: "Método amortización",
                      placeholder: "Francés",
                      options: _vm.amortizationMethod.map((value) => ({
                        value,
                        label: value,
                      })),
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.amortizationMethod,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "amortizationMethod", $$v)
                    },
                    expression: "localPolicy.amortizationMethod",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-tax-rate-" + _vm.index,
                    field: {
                      type: "number",
                      prefixPosition: "right",
                      prefix: "%",
                      isHorizontal: true,
                      label: "Tasa impuesto",
                      placeholder: "0.19",
                    },
                    rules: "required|min_value:0|max_value:1",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.taxRate,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "taxRate", $$v)
                    },
                    expression: "localPolicy.taxRate",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-annual-interest-rate-" + _vm.index,
                    field: {
                      type: "number",
                      prefixPosition: "right",
                      prefix: "%",
                      isHorizontal: true,
                      label: "Tasa interés anual",
                      placeholder: "0.05",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.annualInterestRate,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "annualInterestRate", $$v)
                    },
                    expression: "localPolicy.annualInterestRate",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id:
                      "policy-credit-insurance-percentage-financed-" +
                      _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "% seguro crédito financiado",
                      placeholder: "0.1",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.creditInsurancePercentageFinanced,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localPolicy,
                        "creditInsurancePercentageFinanced",
                        $$v
                      )
                    },
                    expression: "localPolicy.creditInsurancePercentageFinanced",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id:
                      "policy-operational-expenses-number-of-months-" +
                      _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "Meses gastos operacionales",
                      placeholder: "12",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.operationalExpensesNumberOfMonths,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localPolicy,
                        "operationalExpensesNumberOfMonths",
                        $$v
                      )
                    },
                    expression: "localPolicy.operationalExpensesNumberOfMonths",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-property-insurance-monthly-rate-" + _vm.index,
                    field: {
                      type: "number",
                      prefixPosition: "right",
                      prefix: "%",
                      isHorizontal: true,
                      label: "Tasa seguro propiedad",
                      placeholder: "0.002",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.propertyInsuranceMonthlyRate,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localPolicy,
                        "propertyInsuranceMonthlyRate",
                        $$v
                      )
                    },
                    expression: "localPolicy.propertyInsuranceMonthlyRate",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-subsidy-rate-" + _vm.index,
                    field: {
                      type: "number",
                      prefixPosition: "right",
                      prefix: "%",
                      isHorizontal: true,
                      label: "Tasa subsidio",
                      placeholder: "0.05",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.subsidyRate,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "subsidyRate", $$v)
                    },
                    expression: "localPolicy.subsidyRate",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-deed-expenses-" + _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "Gastos escritura",
                      placeholder: "50000",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.deedExpenses,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "deedExpenses", $$v)
                    },
                    expression: "localPolicy.deedExpenses",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-title-study-expenses-" + _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "Gastos estudio título",
                      placeholder: "20000",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.titleStudyExpenses,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "titleStudyExpenses", $$v)
                    },
                    expression: "localPolicy.titleStudyExpenses",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-real-estate-expenses-rate-" + _vm.index,
                    field: {
                      type: "number",
                      prefixPosition: "right",
                      prefix: "%",
                      isHorizontal: true,
                      label: "% Gastos inmobiliarios",
                      placeholder: "0.01",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.realEstateExpensesRate,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "realEstateExpensesRate", $$v)
                    },
                    expression: "localPolicy.realEstateExpensesRate",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-deed-expenses-percentage-" + _vm.index,
                    field: {
                      type: "number",
                      prefixPosition: "right",
                      prefix: "%",
                      isHorizontal: true,
                      label: "% Gastos escritura",
                      placeholder: "0.05",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.deedExpensesPercentage,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "deedExpensesPercentage", $$v)
                    },
                    expression: "localPolicy.deedExpensesPercentage",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-title-study-expenses-percentage-" + _vm.index,
                    field: {
                      type: "number",
                      prefixPosition: "right",
                      prefix: "%",
                      isHorizontal: true,
                      label: "% Gastos estudio título",
                      placeholder: "0.02",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.titleStudyExpensesPercentage,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localPolicy,
                        "titleStudyExpensesPercentage",
                        $$v
                      )
                    },
                    expression: "localPolicy.titleStudyExpensesPercentage",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-real-estate-expenses-percentage-" + _vm.index,
                    field: {
                      type: "number",
                      prefixPosition: "right",
                      prefix: "%",
                      isHorizontal: true,
                      label: "% Gastos inmobiliarios",
                      placeholder: "0.01",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.realEstateExpensesPercentage,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localPolicy,
                        "realEstateExpensesPercentage",
                        $$v
                      )
                    },
                    expression: "localPolicy.realEstateExpensesPercentage",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-operational-expenses-interest-" + _vm.index,
                    field: {
                      type: "select",
                      isHorizontal: true,
                      label: "Interés gastos operacionales",
                      placeholder: ".",
                      options: _vm.operationalExpensesInterest.map((value) => ({
                        value,
                        label: value,
                      })),
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.operationalExpensesInterest,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localPolicy,
                        "operationalExpensesInterest",
                        $$v
                      )
                    },
                    expression: "localPolicy.operationalExpensesInterest",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-credit-min-amount-" + _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "Monto Mín Crédito",
                      placeholder: "100000",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.creditMinAmount,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "creditMinAmount", $$v)
                    },
                    expression: "localPolicy.creditMinAmount",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-life-insurance-monthly-rate-" + _vm.index,
                    field: {
                      type: "number",
                      prefixPosition: "right",
                      prefix: "%",
                      isHorizontal: true,
                      label: "lifeInsuranceMonthlyRate",
                      placeholder: "0.001",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value:
                      _vm.localPolicy.lifeInsuranceMonthlyRateRanges[0]
                        .lifeInsuranceMonthlyRate,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localPolicy.lifeInsuranceMonthlyRateRanges[0],
                        "lifeInsuranceMonthlyRate",
                        $$v
                      )
                    },
                    expression:
                      "localPolicy.lifeInsuranceMonthlyRateRanges[0].lifeInsuranceMonthlyRate",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id:
                      "policy-life-insurance-monthly-rate-max-age-" + _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "maxAge",
                      placeholder: "0.001",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value:
                      _vm.localPolicy.lifeInsuranceMonthlyRateRanges[0].maxAge,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localPolicy.lifeInsuranceMonthlyRateRanges[0],
                        "maxAge",
                        $$v
                      )
                    },
                    expression:
                      "localPolicy.lifeInsuranceMonthlyRateRanges[0].maxAge",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-min-age-codebtor-" + _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "lifeInsuranceMonthlyRate MinAge Debtor",
                      placeholder: "0.001",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value:
                      _vm.localPolicy.lifeInsuranceDebtorMonthlyRateRanges[0]
                        .minAge,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localPolicy.lifeInsuranceDebtorMonthlyRateRanges[0],
                        "minAge",
                        $$v
                      )
                    },
                    expression:
                      "localPolicy.lifeInsuranceDebtorMonthlyRateRanges[0].minAge",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id:
                      "policy-life-insurance-monthly-rate-codebtor-" +
                      _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "lifeInsuranceMonthlyRate Codebtor",
                      placeholder: "65",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value:
                      _vm.localPolicy.lifeInsuranceCodebtorMonthlyRateRanges[0]
                        .lifeInsuranceMonthlyRate,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localPolicy
                          .lifeInsuranceCodebtorMonthlyRateRanges[0],
                        "lifeInsuranceMonthlyRate",
                        $$v
                      )
                    },
                    expression:
                      "localPolicy.lifeInsuranceCodebtorMonthlyRateRanges[0].lifeInsuranceMonthlyRate",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-max-age-codebtor-" + _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "trumaxAgee codebtor",
                      placeholder: "65",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value:
                      _vm.localPolicy.lifeInsuranceCodebtorMonthlyRateRanges[0]
                        .maxAge,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localPolicy
                          .lifeInsuranceCodebtorMonthlyRateRanges[0],
                        "maxAge",
                        $$v
                      )
                    },
                    expression:
                      "localPolicy.lifeInsuranceCodebtorMonthlyRateRanges[0].maxAge",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-is-credit-insurance-accelerated-" + _vm.index,
                    field: {
                      type: "switch",
                      isHorizontal: true,
                      label: "¿Es acelerado el seguro de crédito?",
                      placeholder: "Activo",
                      size: "is-small",
                    },
                    rules: "",
                  },
                  model: {
                    value: _vm.localPolicy.isCreditInsuranceAccelerated,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localPolicy,
                        "isCreditInsuranceAccelerated",
                        $$v
                      )
                    },
                    expression: "localPolicy.isCreditInsuranceAccelerated",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-life-insurance-type-of-premium-" + _vm.index,
                    field: {
                      type: "select",
                      isHorizontal: true,
                      label: "Tipo prima seguro",
                      placeholder: "constante",
                      options: _vm.lifeInsuranceTypeOfPremium.map((value) => ({
                        value,
                        label: value,
                      })),
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.lifeInsuranceTypeOfPremium,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localPolicy,
                        "lifeInsuranceTypeOfPremium",
                        $$v
                      )
                    },
                    expression: "localPolicy.lifeInsuranceTypeOfPremium",
                  },
                }),
                _c("BaseInput", {
                  attrs: {
                    id: "policy-credit-length-by-default-" + _vm.index,
                    field: {
                      type: "number",
                      isHorizontal: true,
                      label: "Longitud crédito",
                      placeholder: "120",
                    },
                    rules: "required",
                    size: "is-small",
                  },
                  model: {
                    value: _vm.localPolicy.creditLenghtByDefault,
                    callback: function ($$v) {
                      _vm.$set(_vm.localPolicy, "creditLenghtByDefault", $$v)
                    },
                    expression: "localPolicy.creditLenghtByDefault",
                  },
                }),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "buttons" },
            [
              _c(
                "b-button",
                { attrs: { type: "is-text" }, on: { click: _vm.cancelPolicy } },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "b-button",
                {
                  attrs: { type: "is-danger", "data-cy": "policy-change" },
                  on: { click: _vm.emitPolicyChange },
                },
                [_vm._v(" Aplicar ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }